import { useSafeArea } from "@provider/safe-area/use-safe-area";
import { Pressable, Text, View } from "dripsy";
import * as React from "react";
import { Platform } from "react-native";
import { create } from "zustand";

type ToastState = { text: string | null; show: (v: string | null) => void };
const useToast = create<ToastState>((set) => ({
  show: (text: string | null) => {
    set({ text });
    if (text) {
      setTimeout(() => {
        set({ text: null });
      }, 3000);
    }
  },
  text: null,
}));

export const toast = {
  show: (message: string | null) => useToast.getState().show(message),
};

export default function Toast() {
  const { text, show } = useToast();
  const { top, left, right } = useSafeArea();
  const pointerEventsProps =
    Platform.OS !== "web" ? { pointerEvents: "box-none" as const } : {};

  if (!text) {
    return null;
  }
  return (
    <View
      {...pointerEventsProps}
      sx={{
        position: "absolute",
        top,
        left,
        right,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000000,
        ...(Platform.OS === "web" ? { pointerEvents: "box-none" } : {}),
      }}
    >
      <Pressable onPressIn={() => show(null)}>
        <View
          sx={{
            backgroundColor: "rgba(0,0,0,0.9)",
            padding: 10,
            borderRadius: 10,
            margin: 10,
            marginTop: Platform.select({ web: 110, default: 10 }),
            alignSelf: "center",
          }}
        >
          <Text
            sx={{
              color: "#fff",
            }}
          >
            {text || "................."}
          </Text>
        </View>
      </Pressable>
    </View>
  );
}
